import { render, staticRenderFns } from "./WearTight.vue?vue&type=template&id=76d18f3f&"
import script from "./WearTight.vue?vue&type=script&lang=js&"
export * from "./WearTight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports